// format: 123K
export function formatRowsSynced(rows: number) {
  return new Intl.NumberFormat(navigator.language, {
    notation: "compact",
    compactDisplay: "short",
  }).format(rows);
}
